import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { Slider } from './slider.js';
import { hsvaToHslString } from '../utils/convert.js';
import { clamp, round } from '../utils/math.js';
export var Hue = /*#__PURE__*/function (_Slider) {
  _inherits(Hue, _Slider);
  var _super = _createSuper(Hue);
  function Hue(root) {
    _classCallCheck(this, Hue);
    return _super.call(this, root, 'hue', 'aria-label="Hue" aria-valuemin="0" aria-valuemax="360"', false);
  }
  _createClass(Hue, [{
    key: "update",
    value: function update(_ref) {
      var h = _ref.h;
      this.h = h;
      this.style([{
        left: "".concat(h / 360 * 100, "%"),
        color: hsvaToHslString({
          h: h,
          s: 100,
          v: 100,
          a: 1
        })
      }]);
      this.el.setAttribute('aria-valuenow', "".concat(round(h)));
    }
  }, {
    key: "getMove",
    value: function getMove(offset, key) {
      // Hue measured in degrees of the color circle ranging from 0 to 360
      return {
        h: key ? clamp(this.h + offset.x * 360, 0, 360) : 360 * offset.x
      };
    }
  }]);
  return Hue;
}(Slider);